// @flow

import { connect } from 'react-redux';
import { WorkInfo } from '../../components/works';
import { titleCase, formatArtistName } from '../../utilities/text';

const mapState = ({ search }) => ({
  className: 'member-works',
  title: titleCase(formatArtistName(search.searchMeta.artistName)),
  backLinkTo: '/memberworks',
  backLinkText: `${titleCase(formatArtistName(search.searchMeta.artistName))}'s Works`,
});

export default connect(
  mapState,
)(WorkInfo);
